module.exports = {
  openMenu (el, done) { // open up the menu
    console.log('yooooooooooooo')
    // var backBtn = document.getElementById('menuIcon')
    var menuBtn = document.getElementById('menuBtn')
    var appWrapper = document.body
    if (el.classList.contains('back')) {
      // are the contact details opened up??
      // var menu = document.getElementById('menu')
      // var contact = document.getElementById('contact')
      var contactImage = document.getElementById('bsdBtn')
      var innerSlider = document.getElementById('innerSlider')
      el.classList.remove('back')
      contactImage.classList.remove('true')
      // window.Velocity(menu, { left: '0vw' }, { duration: 1000 })
      window.Velocity(innerSlider, { left: '0vw', transform: 'translateY(-50%)' }, { duration: 700, complete: done })
      // window.Velocity(contact, { top: '0' }, { duration: 100 })
      // window.Velocity(contact, { right: '-100vw' }, { duration: 1000, complete: done })
    } else if (menuBtn.classList.contains('contactOpen')) {
      document.getElementById('movingHeader').classList.remove('true')
      document.getElementById('header').classList.remove('true')
      document.getElementById('menuBtn').classList.remove('true')
      document.getElementById('wrap').classList.remove('true')
      menuBtn.classList.remove('contactOpen')
      var bodyStyle = appWrapper.style.overflow
      var linodes = document.getElementById('menu').childNodes
      for (var a = 0; a < linodes.length; a++) {
        if (linodes[a].textContent !== ' ') {
          linodes[a].classList.toggle('fadeIn')
        }
      }
      if (bodyStyle === 'hidden') {
        appWrapper.style.overflowY = 'scroll'
      } else {
        appWrapper.style.overflow = 'hidden'
      }
    }
  },
  loadNewPage () {
    // console.log('loading these styles')
    // var menuBtn = document.getElementById('menuBtn')
    // var appWrapper = document.body
    document.getElementById('movingHeader').classList.add('true')
    document.getElementById('header').classList.add('true')
    document.getElementById('menuBtn').classList.add('true')
    document.getElementById('wrap').classList.add('true')
    var generalWrap = document.getElementById('wrap')
    generalWrap.classList.add('true')
  },
  openContact (done) { // open up the contact details
    // console.log('opening contact now')
    var appWrapper = document.body
    // var bodyStyle = appWrapper.style.overflow
    // console.log('2' + bodyStyle)
    // var menu = document.getElementById('menu')
    // window.Velocity(menu, { left: '-100vw' }, { duration: 1000 })
    var innerSlider = document.getElementById('innerSlider')
    // var contact = document.getElementById('contact')
    var backBtn = document.getElementById('menuIcon')
    var contactImage = document.getElementById('bsdBtn')
    // console.log(document.getElementById('header'))
    // window.Velocity(contact, { top: '-165px' }, { duration: 100 })
    // window.Velocity(contact, { right: '50%', translateX: '60%' }, { duration: 1000, complete: done })
    window.Velocity(innerSlider, { left: '-100vw' }, { duration: 700, complete: done })
    backBtn.classList.add('back')
    contactImage.classList.add('true')
    var linodes = document.getElementById('menu').childNodes
    for (var a = 0; a < linodes.length; a++) {
      if (linodes[a].textContent !== ' ') {
        linodes[a].classList.add('fadeIn')
      }
    }
    //
    // removed the standard if/else statement here to stop the error on the
    // flock page with the hi logo that appears on hover
    appWrapper.style.overflow = 'hidden'
  },
  openContact2 (done) {
    // console.log('step 3')
    var innerSlider = document.getElementById('innerSlider')
    window.Velocity(innerSlider, { left: '-100vw', transform: 'translateY(-50%)' }, { duration: 700, complete: done })
    var linodes = document.getElementById('menu').childNodes
    for (var a = 0; a < linodes.length; a++) {
      if (linodes[a].textContent !== ' ') {
        linodes[a].classList.toggle('fadeIn')
      }
    }
    var appWrapper = document.body
    var bodyStyle = appWrapper.style.overflow
    if (bodyStyle === 'hidden') {
      appWrapper.style.overflowY = 'scroll'
    } else {
      appWrapper.style.overflow = 'hidden'
    }
  },
  closeMenu () {
    // console.log('closing menu!....')
    var generalWrap = document.getElementById('wrap')
    var header = document.getElementById('movingHeader')
    var menuBtn = document.getElementById('menuBtn')
    var contactImage = document.getElementById('bsdBtn')
    var appWrapper = document.body
    header.classList.remove('true')
    contactImage.classList.remove('true')
    document.getElementById('header').classList.remove('true')
    menuBtn.classList.remove('true')
    menuBtn.classList.remove('contactOpen')
    document.getElementById('curtain').classList.remove('true')
    generalWrap.classList.toggle('true')
    appWrapper.style.overflowY = 'scroll'
    var linodes = document.getElementById('menu').childNodes
    for (var a = 0; a < linodes.length; a++) {
      // console.log(linodes[a])
      if (linodes[a].textContent !== ' ') {
        linodes[a].classList.remove('fadeIn')
      }
    }
  },
  hideHeader () {
    // function to close the menu on clicking of wrapper
    var headerSection = document.getElementById('header')
    var contact = document.getElementById('movingHeader')
    // console.log(contact.classList)
    if (headerSection.classList.contains('true') && !contact.classList.contains('contact')) {
      // console.log('this one')
      this.closeMenu()
    }
    if (contact.classList.contains('true') && !contact.classList.contains('contact')) {
      // console.log('that one')
      this.closeMenu()
    } else {
      // console.log('header is not open')
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/menu.js